import React, { useEffect, useState, useContext } from 'react';
import { SiteContext } from 'four-nets';
import superagent from 'superagent';

// used for pregenerate in react. Temporary solution, it will all get rewrited in django anyway
const tailwind_styles = 'absolute bg-gradient-to-b bg-white border border-gray-300 bottom-0 cursor-pointer flex flex-col font-bold from-10% from-gray-800/0 gap-1 gap-2 grid grid-cols-1 h-48 hidden hover:bg-[#e5e5e5] hover:bg-gray-100 items-center justify-between left-0 lg:grid-cols-1 lg:hidden mb-4 md:mx-0 mx-1 object-center object-cover p-0 p-1 p-3 p-4 place-self-center pt-5 px-2 relative right-0 rounded-b-md rounded-lg rounded-md shadow-md sm:flex sm:gap-3 sm:grid-cols-3 text-gray-700 text-primary-700 text-white text-xs to-gray-800/80 via-20% via-gray-800/80 w-fit w-full'

const HtmlComponent = ({ url }) => {
    const [loading, setLoading] = useState(true);
    const [html, setHtml] = useState<string | null>(null);

    const site = useContext(SiteContext);
    const baseUrl = site.url;

    const someFunction = async () => {
        const response = await superagent.get(baseUrl + url);
        setHtml(response.text);
        setLoading(false);
    };

    useEffect(() => {
        try {
            someFunction();
        } catch {
            console.error('error');
        }
    }, []);

    if (loading) {
        return <span>Načítava sa...</span>;
    }

    if (html === null) {
        return <span>Chyba...</span>;
    }

    return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
};

export default HtmlComponent;
